import React from 'react';
import Footer from '../../E-components/Footer';
import CustomerSection from '../CustomerSection';
import './CustomerDemand.css'


export default function Products() {
  return( 
  <div className='CustomerDemand'>
      <div className='header_customer'>
              <nav>
              <div className='navbar-container'>
               <div className='logo'><h1>Shuper</h1></div>
                  <ul className='Customer-nav-links'> 
                    
                    <li><a href='#'>回其他頁面</a></li>
                    <li><a href='#'>發案問題</a></li>
                    <li><a href='#'>會員登入</a></li>
                  </ul>
                  <a href='#' className='register-btn'>註冊</a>
              </div>
              </nav>
      <div className='Customer-container'>
        <h1>買東西總是琳瑯滿目<br/>告訴我們你想要買什麼東西<br/>不需自己再去找<br/>我們提供給您最好的選擇！</h1>
        <div className='search-bar'>
          <form>
            <div className='cat-input'>
              <label>
                商品種類
                </label>
                <input type='text' placeholder='您想要什麼樣特質的商品'/>
            </div>
            <div>
              <label>
                商品價格
                </label>
                <input type='text' placeholder='您大概的預算'/>
            </div>
            <div>
              <label>
                商品尺寸
                </label>
                <input type='text' placeholder='大概商品的大小'/>
            </div>
            <div>
              <label>
                商品配色
                </label>
                <input type='text' placeholder='大概商品的配色'/>
            </div>
            <button type="submit"><img src='/img/search.png' alt='' /></button>
          </form>
        </div>
      </div>
    </div>

            <div className='Customer-container'>
              <h2 className='sub-title'>找不到商品，沒關係交給我們來處理</h2>
                    <div className='category'>
                        <div>
                          <img src='https://www.taiwanviptravel.com/articles/images/huashan1914-img2.jpg'/>
                              <span>
                                <h3>
                                  生活服飾區
                                </h3>
                                <p>華山文創園區</p>
                              </span>
                          </div>
                          <div>
                          <img src='https://www.taiwanviptravel.com/articles/images/songshan-cultural-park-img3.jpg'/>
                              <span>
                                <h3>
                                  生活服飾區
                                </h3>
                                <p>松菸文創園區</p>
                              </span>
                          </div>
                          <div>
                          <img src='https://www.taiwanviptravel.com/articles/images/huashan1914-img2.jpg'/>
                              <span>
                                <h3>
                                  生活飾品區
                                </h3>
                              </span>
                          </div>
                          <div>
                          <img src='https://www.taiwanviptravel.com/articles/images/huashan1914-img2.jpg'/>
                              <span>
                                <h3>
                                  生活飾品區
                                </h3>
                              </span>
                          </div>
                          <div>
                          <img src='https://www.taiwanviptravel.com/articles/images/huashan1914-img2.jpg'/>
                              <span>
                                <h3>
                                  生活飾品區
                                </h3>
                              </span>
                          </div>
                          <div>
                          <img src='https://www.taiwanviptravel.com/articles/images/huashan1914-img2.jpg'/>
                              <span>
                                <h3>
                                  生活飾品區
                                </h3>
                              </span>
                          </div>
                          <div>
                          <img src='https://www.taiwanviptravel.com/articles/images/songshan-cultural-park-img3.jpg'/>
                              <span>
                                <h3>
                                  生活飾品區
                                </h3>
                              </span>
                          </div>
                          <div>
                          <img src='https://www.taiwanviptravel.com/articles/images/songshan-cultural-park-img3.jpg'/>
                              <span>
                                <h3>
                                  生活飾品區
                                </h3>
                              </span>
                          </div>
                          
                    </div>
            
              <h2 className='sub-title'>熱門客製化案子</h2>
              <div className = 'trending'>
                    <div>
                      <img src='https://images.pexels.com/photos/7221574/pexels-photo-7221574.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500'/>
                      <h3>職人工匠手做</h3>
                    </div>
                    <div>
                      <img src='https://images.pexels.com/photos/6621468/pexels-photo-6621468.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260'/>
                      <h3>貼心客製化小物</h3>
                    </div>
                    <div>
                      <img src='https://images.pexels.com/photos/8549835/pexels-photo-8549835.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500'/>
                      <h3>職人工匠手做</h3>
                    </div>
                    <div>
                      <img src='https://images.pexels.com/photos/1191522/pexels-photo-1191522.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500'/>
                      <h3>職人工匠手做</h3>
                    </div>

              </div>
            
            <div className='more-info'>
              <h3>客製化商品使用佳評</h3>
              <h2>點擊下方觀看使用者回饋</h2>
              <p>我們持續努力，給您商品最高的品質且最符合您的需求</p>
              <a href='#' className='more-info-btn'>更多資訊</a>
            </div>
            <h2 className='sub-title'>文創背後的故事</h2>
              <div className='stories'>
                <div>
              <img src='https://images.pexels.com/photos/5530600/pexels-photo-5530600.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260'/>
              <p>最早的文本問世</p></div>
              <div>
              <img src='https://images.pexels.com/photos/4946841/pexels-photo-4946841.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500'/>
              <p>第一間文創園區</p></div>  
              <div>
              <img src='https://images.pexels.com/photos/6249532/pexels-photo-6249532.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500'/>
              <p>最早的文本問世</p></div>       
              </div>
              <Footer />
            </div>
    </div>
  

  
  );
}
